import { CellContext, ColumnDef } from '@tanstack/react-table';
import React from 'react';
import { GeoDeliveryRow } from './geoDeliveryData';
import { useJobDetailsProvider } from '../../../../../../context/jobDetails';
import { Badge } from '../../../../../../../components/Common/UI/Badge';
import { cn } from '../../../../../../../utils/styles';
import { JobDetailColumnType } from '../subTableConfig';

function CounterBadgeAction({ row, column }: CellContext<GeoDeliveryRow, unknown>) {
  const { handleSelectedTable, selectedTable } = useJobDetailsProvider();
  const { getValue, original } = row;

  const handleClick = () => {
    handleSelectedTable({ row: original.state.code, column: column.id as JobDetailColumnType });
  };

  const isDisabled = getValue(column.id) === 0; // || column.id !== 'percentage'
  const isActiveStyle = selectedTable.row === original.state.code && selectedTable.column === column.id;

  return (
    <Badge
      variant={!isDisabled ? 'counter' : 'counterDisabled'}
      onClick={!isDisabled ? handleClick : undefined}
      className={cn('cursor-pointer hover:bg-addition4-10', {
        'bg-addition4-20 hover:bg-addition4-20': isActiveStyle && !isDisabled,
      })}
    >
      {getValue(column.id)}
      {column.id === 'percentage' ? '%' : null}
    </Badge>
  );
}

export const geoDeliveryCol: ColumnDef<GeoDeliveryRow>[] = [
  {
    accessorKey: 'state',
    header: 'State',
    cell: ({ row }) => (
      <span className="text-xs font-medium tracking-widest uppercase">{row.original.state.label}:</span>
    ),
  },
  {
    accessorKey: 'totalMail',
    header: 'Total mail',
    cell: CounterBadgeAction,
  },
  {
    accessorKey: 'deliveredMail',
    header: 'Delivered Mail',
    cell: CounterBadgeAction,
  },
  {
    accessorKey: 'scannableMail',
    header: 'Scannable Mail',
    cell: CounterBadgeAction,
  },
  {
    accessorKey: 'exceptionMail',
    header: 'Exception Mail',
    cell: CounterBadgeAction,
  },
];

export default geoDeliveryCol;
